import { render, staticRenderFns } from "./AccountSettingConfig.vue?vue&type=template&id=9ed002b4"
import script from "./AccountSettingConfig.vue?vue&type=script&lang=js"
export * from "./AccountSettingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports